import type { ProductLogoSmallProps } from '../types';

export function ProductLogoSmallCertifications({
  size = 20,
  color = '#0070C0',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 422 351"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M183.187 116.965C183.187 142.804 162.241 163.751 136.401 163.751C110.562 163.751 89.6154 142.804 89.6154 116.965C89.6154 91.1258 110.562 70.179 136.401 70.179C162.241 70.179 183.187 91.1258 183.187 116.965Z"
        fill={color}
      />
      <path
        d="M54.5259 237.41C54.5259 209.649 77.0309 187.144 104.792 187.144H168.011C195.772 187.144 218.277 209.649 218.277 237.41V248.945C218.277 253.572 214.526 257.323 209.899 257.323H62.9036C58.2767 257.323 54.5259 253.572 54.5259 248.945V237.41Z"
        fill={color}
      />
      <path
        d="M242.644 105.268C242.644 98.8087 247.881 93.572 254.341 93.572H347.913C354.372 93.572 359.609 98.8087 359.609 105.268C359.609 111.728 354.372 116.965 347.913 116.965H254.341C247.881 116.965 242.644 111.728 242.644 105.268Z"
        fill={color}
      />
      <path
        d="M242.644 163.751C242.644 157.291 247.88 152.055 254.34 152.055H323.946C330.405 152.055 335.642 157.291 335.642 163.751C335.642 170.211 330.405 175.447 323.946 175.447H254.34C247.88 175.447 242.644 170.211 242.644 163.751Z"
        fill={color}
      />
      <path
        d="M0 25.1331C0 11.2525 11.2525 0 25.1331 0H31.1906V31.1906H0V25.1331Z"
        fill={color}
      />
      <path
        d="M388.809 0H394.867C408.748 0 420 11.2525 420 25.1331V31.1906H388.809V0Z"
        fill={color}
      />
      <path
        d="M0 296.311H31.1906V327.502H25.1331C11.2525 327.502 0 316.249 0 302.369V296.311Z"
        fill={color}
      />
      <path d="M31.1906 0H388.809V31.1906H31.1906V0Z" fill={color} />
      <path d="M0 31.1906H31.1906V296.311H0V31.1906Z" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346.761 199.751C388.314 199.751 422 233.438 422 274.991C422 316.545 388.314 350.23 346.761 350.23C305.207 350.23 271.521 316.545 271.521 274.991C271.521 233.437 305.207 199.751 346.761 199.751ZM380.841 246.372C377.717 243.248 372.652 243.248 369.527 246.372L335.462 280.437L324.805 269.779C321.681 266.655 316.616 266.655 313.491 269.779L310.617 272.653C307.493 275.777 307.493 280.843 310.617 283.967L329.806 303.155C332.93 306.279 337.995 306.279 341.119 303.155L383.715 260.559C386.839 257.434 386.839 252.369 383.715 249.245L380.841 246.372Z"
        fill={color}
      />
      <path
        d="M388.809 31.1943H420V175.751C420 182.378 414.628 187.751 408 187.751H400.809C394.182 187.751 388.809 182.378 388.809 175.751V31.1943Z"
        fill={color}
      />
      <path
        d="M31.1087 327.525L31.1087 296.334L226.001 296.334C232.628 296.334 238.001 301.707 238.001 308.334V315.525C238.001 322.153 232.628 327.525 226.001 327.525L31.1087 327.525Z"
        fill={color}
      />
    </svg>
  );
}
